import { ExportReq, HttpService, Records } from "@/core";
import { ExportResp } from "@/core/interface";
import {
  ReceivePageReq,
  ReceivePageResp,
  ReceiveSimpleRecord,
  ReceiveDetailResp,
  ReceiveReq,
  MaterialRecord,
  MaterialPageResp,
  MaterialPageReq,
} from "./receive.interface";
import { OrderService } from "@/views/purchase/order/order.service";

export class ReceiveService {
  static usePageApi() {
    const api = (params: ReceivePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/purchase_receive_order/page",
        params,
      });
    return HttpService.usePagination<ReceivePageResp>(api);
  }

  static useSimpleListApi() {
    const api = (params: any) =>
      HttpService.axios({
        method: "GET",
        url: "/purchase_receive_order/simple/list",
        params,
      });
    return HttpService.useRequest<Records<ReceiveSimpleRecord>>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/purchase_receive_order/${id}`,
      });
    return HttpService.useRequest<ReceiveDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: ReceiveReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_receive_order",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useEditApi() {
    const api = (id: string, data: ReceiveReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/purchase_receive_order/${id}`,
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/purchase_receive_order/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useExportApi() {
    const api = (data: any) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_receive_order/export",
        data,
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static useMaterialImportApi() {
    const api = (url: string, id: string) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_receive_order/import/detail",
        data: { url, id },
      });
    return HttpService.useRequest<Records<MaterialRecord>>(api);
  }

  static useMaterialExportApi() {
    const api = (id: string, titleParamReqs: any) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_receive_order/export/new/detail",
        // data: { ids: [id] },
        data: { ids: [id], titleParamReqs: titleParamReqs },
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }

  static async backfillByContractId(contractId) {
    let result = {
      projectId: "",
      projectName: "",
      partyBCooperationCompanyId: "",
      partyBCooperationCompanyName: "",
    };
    if (!contractId) {
      return result;
    }
    const { run } = OrderService.useDetailApi();
    const res = await run(contractId);
    if (res.respCode === "0000" && res.data) {
      const { purchaseOrderAResp } = res.data;
      result.projectId = purchaseOrderAResp?.projectId as string;
      result.projectName = purchaseOrderAResp?.projectName as string;
      result.partyBCooperationCompanyId = purchaseOrderAResp?.supplierId;
      result.partyBCooperationCompanyName = purchaseOrderAResp?.partyBCooperationCompanyName;
    }
    return { purchaseReceiveOrderInfoReq: result };
  }

  static validDetail(list: MaterialRecord[] = []) {
    if (list.length === 0) {
      return false;
    }
    let valid = true;
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if (!item.currentAogCount || !item.currentSignCount) {
        valid = false;
        break;
      }
    }
    return valid;
  }

  static useOrderMaterialSelect() {
    const api = (data: MaterialPageReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_receive_order/list/material/receivePost",
        data,
      });
    return HttpService.usePagination<MaterialPageResp>(api);
  }
  static receiveAddNew() {
    const api = (data: ReceiveReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_receive_order/add_new",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }
}
